import { HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { ConfigServerService, CustomHttp } from '../../../core';

import { Cidade } from '../cidade';

@Injectable({
  providedIn: 'root'
})
export class CidadeTypeaheadHttpService {
  private pathApi: string;

  constructor(
    configServerService: ConfigServerService,
    private customHttp: CustomHttp
  ) {
    this.pathApi = `${configServerService.getPathApiTypeahead()}/cidade`;
  }

  /** Pesquisa todas as cidades cadastradas */
  search(
    nome: string,
    idEstado?: number,
    idRegiaoGeograficaIntermediaria?: number,
    idRegiaoGeograficaImediata?: number,
    limit?: number
  ): Observable<Cidade[]> {
    let params = new HttpParams();
    params = params.append('nome', nome);
    if (idEstado) {
params = params.append('idEstado', idEstado.toString());
}
    if (idRegiaoGeograficaIntermediaria) {
params = params.append('idRegiaoGeograficaIntermediaria', idRegiaoGeograficaIntermediaria.toString());
}
    if (idRegiaoGeograficaImediata) {
params = params.append('idRegiaoGeograficaImediata', idRegiaoGeograficaImediata.toString());
}
    params = params.append('limit', limit ? limit.toString() : null);
    return this.customHttp.get(this.pathApi, { params });
  }
}
